const logDetailsInitiaState = {
  logDetails: {
    organisationLogDetailsLoading: false,
    organisationLogDetailsSuccess: {},
    organisationLogDetailsError: {},
  },
};

export default logDetailsInitiaState;
